// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2p-2";
export var placeholderIcon = "_2p-3";
export var thumbnailCanvas = "_2p-1";
export var thumbnailWrapper = "_2p-0";